import React, {ReactElement} from 'react'
import {Location, NavigateFunction, Params, useLocation, useNavigate, useParams} from 'react-router-dom'
import {getDeferredNavigate} from './RouterPropsInjectorUtil'

export interface RouterPageProps {
    navigate: NavigateFunction
}

export type RouterProps = {
    params: Params;
    location: Location;
    navigate: NavigateFunction
}

type Props = {
    children: (props: RouterProps) => ReactElement;
};

const RouterPropsInjector: React.FC<Props> = (props: Props) => {
    const params = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    return props.children({params, location, navigate: getDeferredNavigate(navigate)})
}

export default RouterPropsInjector
